import React from "react";


const Counter = () => {

    return (
        <>
         {/* Statistics Section */}
      <section className="statistics-section">
        <div className="stat">
          <h2>673</h2>
          <p>Happy Students</p>
        </div>
        <div className="stat">
          <h2>12</h2>
          <p>Approved Courses</p>
        </div>
        <div className="stat">
          <h2>20</h2>
          <p>Certified Teachers</p>
        </div>
        <div className="stat">
          <h2>5</h2>
          <p>Award Won</p>
        </div>
      </section>
      {/* Photo Gallery Section */}
      <section className="gallery-section">
        <h2 className="photos">The School Life / Photo Gallery</h2>
        <div className="gallery">
          <img src="/pic/DSC_0077.jpg" alt="Gallery 1" />
          <img src="/pic/DSC_0104.jpg" alt="Gallery 2" />
          <img src="/pic/DSC_0109.jpg" alt="Gallery 3" />
          <img src="/pic/DSC_0121.jpg" alt="Gallery 4" />
          <img src="/pic/DSC_0163.jpg" alt="Gallery 5" />
        </div>
      </section>
        </>
    )
}
export default Counter;